<template>
<div :is="termType"></div>
</template>

<script>
import service_agreement from './TermServiceAgreement.vue';
import personal_info from './TermPersonalInfo.vue';
import marketing from './TermMarketing.vue';
import personal_info_agree from './TermPersonalInfoAgree.vue';

import insurance from './TermInsurance.vue';
import insurance_marketing from './TermInsuranceMarketing.vue';
import insurance_personal_info_agree from './TermInsurancePersonalInfoAgree.vue';

import escalation from './TermEscalation.vue';
export default {
    name: 'TermContentView',
    components: {
        //필수 약관
        service_agreement,
        personal_info,
        marketing,
        personal_info_agree,
        
        //보험약관
        insurance,
        insurance_marketing,
        insurance_personal_info_agree,
        escalation,
    },
    props: {
        termType: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>

</style>